<div style="width:100%;overflow:auto;" >
  <div data-testid="dashboard-header-widget" class="dx-widget noselect">
    <dx-toolbar data-testid="dashboard-header-toolbar">
      <dxi-item location="before" style="display: flex;">
        <ng-container *ngFor="let filter of (dashboardFilterOptions$ | async)">
          <div data-testid="dashboard-header-filter-title" class="filter-title">{{filter.name}}:</div>
          <dx-radio-group data-testid="dashboard-header-radio-group"
        [dataSource]="filter.items"
        layout="horizontal"
        displayExpr="text"
        valueExpr="text"
        [value]="filter.selectedItem"
        (onValueChanged)="onValueChanged($event, filter)"
        >
          </dx-radio-group>
        </ng-container>
      </dxi-item>

      <dxi-item location="before">
        <div *dxTemplate style="padding-left: 20px;">
            <dx-check-box data-testid="dashboard-header-show-completed-check-box" (onValueChanged)="showCompletedValueChanged($event)"
            text="Show Completed"
            [value]="showCompleted">
            </dx-check-box>
        </div>
      </dxi-item>

      <dxi-item location="before">
        <div *dxTemplate style="padding-left: 20px;">
            <dx-check-box data-testid="dashboard-header-show-rejected-check-box" (onValueChanged)="showRejectedValueChanged($event)"
            text="Show Rejected"
            [value]="showRejected">
            </dx-check-box>
        </div>
      </dxi-item>

    </dx-toolbar>
    </div>
    </div>